import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpFilial from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadUsuario() {
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [codusuario, setCodUsuario] = useState(0);
    const [nome, setNome] = useState("");
    const [usuario, setUsuario] = useState("");
    const [senha, setSenha] = useState("");
    const [tipoacesso, setTipoAcesso] = useState("");
    const [setorserraria, setSetorSerraria] = useState("");
    const [setormontagemgrade, setSetorMontagemGrade] = useState("");
    const [setormarcenaria, setSetorMarcenaria] = useState("");
    const [setorcolagemespuma, setSetorColagemEspuma] = useState("");
    const [setorcortetecido, setSetorCorteTecido] = useState("");
    const [setorcostura, setSetorCostura] = useState("");
    const [setorenchimentoalmofada, setSetorEnchimentoAlmofada] = useState("");
    const [setorcolagemtecido, setSetorColagemTecido] = useState("");
    const [setorcoberta, setSetorCoberta] = useState("");
    const [setorentrega, setSetorEntrega] = useState("");
    const [ativo, setAtivo] = useState("");

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenFilial, setIsOpenFilial] = useState(false);

    const { selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto    

    const [codempresa, setCodEmpresa] = useState(0);
    const [listaEmpresa, setListaEmpresa] = useState([]);
    const [listaFilial, setListaFilial] = useState([]);
    const [codacesso, setCodAcesso] = useState(0);

    const handleOpen = (cad) => {
        setCodUsuario(cad.codusuario);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOpenFilial = (cad) => {
        setCodAcesso(cad.codacesso);
        setIsOpenFilial(true);
    };

    const handleConfirmaFilial = () => {
        setIsOpenFilial(false);
        ExcluirFilial();
    };

    const handleCloseFilial = () => {
        setIsOpenFilial(false);
    };

    function ListarEmpresa() {
        api
            .get("v1/cadastro/empresa", {
                params: {
                    busca: "",
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaEmpresa(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarFilial() {
        api
            .get("v1/cadastro/usuario/usuarioempresa", {
                params: {                    
                    codusuario
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaFilial(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarUsuario() {
        api
            .get("v1/cadastro/usuario", {
                params: {
                    busca: abusca,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarUsuario();
        },
        [abusca, selectedCompany]
    );

    function Cadastrar() {
        api
            .post(
                "v1/cadastro/usuario",
                {
                    nome,
                    usuario,
                    senha,
                    tipoacesso,
                    setorserraria,
                    setormontagemgrade,
                    setormarcenaria,
                    setorcolagemespuma,
                    setorcortetecido,
                    setorcostura,
                    setorenchimentoalmofada,
                    setorcolagemtecido,
                    setorcoberta,
                    setorentrega,
                    ativo,
                    excluido: "N"
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarUsuario();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function CadastrarAcessoFilial() {
        if (novo) {
            api
                .post(
                    "v1/cadastro/usuario",
                    {
                        nome,
                        usuario,
                        senha,
                        tipoacesso,
                        setorserraria,
                        setormontagemgrade,
                        setormarcenaria,
                        setorcolagemespuma,
                        setorcortetecido,
                        setorcostura,
                        setorenchimentoalmofada,
                        setorcolagemtecido,
                        setorcoberta,
                        setorentrega,
                        ativo,
                        excluido: "N"
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(function (response) {
                    setnovo(false);
                    setCodUsuario(response.data.codusuario);

                    api
                        .post(
                            "v1/cadastro/usuario/usuarioempresa",
                            {
                                codusuario: response.data.codusuario,
                                codempresa,
                                excluido: "N"
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },
                            }
                        )
                        .then(() => {
                            ListarFilial();
                        })
                        .catch(function (err) {
                            console.log("ops! ocorreu um erro: " + err);
                        });
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            api
                .post(
                    "v1/cadastro/usuario/usuarioempresa",
                    {
                        codusuario,
                        codempresa,
                        excluido: "N"
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    ListarFilial();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }
    }

    function Editar() {
        api
            .put(
                "v1/cadastro/usuario",
                {
                    nome,
                    usuario,
                    senha,
                    tipoacesso,
                    setorserraria,
                    setormontagemgrade,
                    setormarcenaria,
                    setorcolagemespuma,
                    setorcortetecido,
                    setorcostura,
                    setorenchimentoalmofada,
                    setorcolagemtecido,
                    setorcoberta,
                    setorentrega,
                    ativo,
                    codusuario
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarUsuario();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("v1/cadastro/usuario", {
                params: {
                    codusuario,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarUsuario();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirFilial() {
        api
            .delete("v1/cadastro/usuario/usuarioempresa", {
                params: {
                    codacesso,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarFilial();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setCodUsuario(0);
        setNome("");
        setUsuario("");
        setSenha("");
        setTipoAcesso("TODOS");
        setSetorSerraria("N");
        setSetorMontagemGrade("N");
        setSetorMarcenaria("N");
        setSetorColagemEspuma("N");
        setSetorCorteTecido("N");
        setSetorCostura("N");
        setSetorEnchimentoAlmofada("N");
        setSetorColagemTecido("N");
        setSetorCoberta("N");
        setSetorEntrega("N");
        setAtivo("S");

        ListarEmpresa();
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setCodUsuario(cad.codusuario);
        setNome(cad.nome);
        setUsuario(cad.usuario);
        setSenha(cad.senha);
        setTipoAcesso(cad.tipoacesso);
        setSetorSerraria(cad.setorserraria);
        setSetorMontagemGrade(cad.setormontagemgrade);
        setSetorMarcenaria(cad.setormarcenaria);
        setSetorColagemEspuma(cad.setorcolagemespuma);
        setSetorCorteTecido(cad.setorcortetecido);
        setSetorCostura(cad.setorcostura);
        setSetorEnchimentoAlmofada(cad.setorenchimentoalmofada);
        setSetorColagemTecido(cad.setorcolagemtecido);
        setSetorCoberta(cad.setorcoberta);
        setSetorEntrega(cad.setorentrega);
        setAtivo(cad.ativo);

        ListarEmpresa();
        ListarFilial();
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <div>
                            <div>
                                <PopUp isOpen={isOpen} onClose={handleClose}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse registro?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirma}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUp>

                                <PopUpFilial isOpen={isOpenFilial} onClose={handleCloseFilial}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir essa filial?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirmaFilial}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleCloseFilial}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUpFilial>
                            </div>

                            <Modal
                                isOpen={showform}
                                onRequestClose={closeModal}
                                overlayClassName="modal-overlay"
                                className="modal-content modal-xl"
                            >
                                <div className="container-fluid h-100">
                                    <div className="modal-header">
                                        {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                        <button type="button" className="btn-close" onClick={closeModal}></button>
                                    </div>

                                    <div className="modal-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                    <label htmlFor="nome" className="form-label">
                                                        Nome
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="nome"
                                                        className="form-control"
                                                        placeholder="Nome"
                                                        value={nome}
                                                        onChange={(e) => setNome(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="usuario" className="form-label">
                                                        Usuário
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="usuario"
                                                        className="form-control"
                                                        placeholder="Usuário"
                                                        value={usuario}
                                                        onChange={(e) => setUsuario(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="senha" className="form-label">
                                                        Senha
                                                    </label>
                                                    <input
                                                        type="password"
                                                        id="senha"
                                                        className="form-control"
                                                        placeholder="Senha"
                                                        value={senha}
                                                        onChange={(e) => setSenha(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <div>
                                                        <label htmlFor="tipoacesso" className="form-label">
                                                            Tipo Acesso
                                                        </label>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="tipoacesso"
                                                                value="TODOS"
                                                                onChange={(e) => setTipoAcesso(e.target.value)}
                                                                checked={tipoacesso === "TODOS"}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                for="inlineRadio1"
                                                            >
                                                                Todos
                                                            </label>
                                                        </div>

                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="tipoacesso"
                                                                value="SITE"
                                                                onChange={(e) => setTipoAcesso(e.target.value)}
                                                                checked={tipoacesso === "SITE"}
                                                            />
                                                            <label className="form-check-label" htmlfor="ativo2">
                                                                Site
                                                            </label>
                                                        </div>

                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="tipoacesso"
                                                                value="APP"
                                                                onChange={(e) => setTipoAcesso(e.target.value)}
                                                                checked={tipoacesso === "APP"}
                                                            />
                                                            <label className="form-check-label" htmlfor="ativo2">
                                                                App
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <div>
                                                        <label htmlFor="ativo1" className="form-label">
                                                            Ativo
                                                        </label>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="S"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "S"}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                for="inlineRadio1"
                                                            >
                                                                Sim
                                                            </label>
                                                        </div>

                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="N"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "N"}
                                                            />
                                                            <label className="form-check-label" htmlfor="ativo2">
                                                                Não
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <label htmlFor="tipo1" className="form-label">
                                                        Tipo de Funcionário
                                                    </label>

                                                    <br />

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorserraria"
                                                            checked={setorserraria === "S"}
                                                            onChange={(e) =>
                                                                setSetorSerraria(e.target.checked ? "S" : "N")
                                                            }
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Serraria
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setormontagemgrade"
                                                            checked={setormontagemgrade === "S"}
                                                            onChange={(e) =>
                                                                setSetorMontagemGrade(
                                                                    e.target.checked ? "S" : "N"
                                                                )
                                                            }
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Montagem Grade
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setormarcenaria"
                                                            checked={setormarcenaria === "S"}
                                                            onChange={(e) =>
                                                                setSetorMarcenaria(e.target.checked ? "S" : "N")
                                                            }
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Marcenária
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorcolagemespuma"
                                                            onChange={(e) =>
                                                                setSetorColagemEspuma(
                                                                    e.target.checked ? "S" : "N"
                                                                )
                                                            }
                                                            checked={setorcolagemespuma === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Colagem Espuma
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorcortetecido"
                                                            onChange={(e) =>
                                                                setSetorCorteTecido(e.target.checked ? "S" : "N")
                                                            }
                                                            checked={setorcortetecido === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Corte Tecido
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorcostura"
                                                            onChange={(e) =>
                                                                setSetorCostura(e.target.checked ? "S" : "N")
                                                            }
                                                            checked={setorcostura === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Costura
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorenchimentoalmofada"
                                                            onChange={(e) =>
                                                                setSetorEnchimentoAlmofada(e.target.checked ? "S" : "N")
                                                            }
                                                            checked={setorenchimentoalmofada === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Enchimento Almofada
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorcolagemtecido"
                                                            onChange={(e) =>
                                                                setSetorColagemTecido(e.target.checked ? "S" : "N")
                                                            }
                                                            checked={setorcolagemtecido === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Colagem Tecido
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorcoberta"
                                                            onChange={(e) =>
                                                                setSetorCoberta(
                                                                    e.target.checked ? "S" : "N"
                                                                )
                                                            }
                                                            checked={setorcoberta === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Coberta
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="setorentrega"
                                                            onChange={(e) =>
                                                                setSetorEntrega(
                                                                    e.target.checked ? "S" : "N"
                                                                )
                                                            }
                                                            checked={setorentrega === "S"}
                                                        />
                                                        <label className="form-check-label">
                                                            Setor Entrega
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>                                                
                                                <hr />
                                            </div>                                            

                                            <div className="row">
                                                <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                                    <label htmlFor="filial" className="form-label">
                                                        Filial
                                                    </label>
                                                    <select
                                                        id="filial"
                                                        className="form-select"
                                                        value={codempresa}
                                                        onChange={(e) => setCodEmpresa(e.target.value)}
                                                    >
                                                        <option value="0">Escolha a filial</option>
                                                        {listaEmpresa.map(function (emp) {
                                                            return (
                                                                <option
                                                                    key={emp.codempresa}
                                                                    value={emp.codempresa}
                                                                >
                                                                    {emp.nomefantasia} - {emp.bairro}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btnnovo"
                                                        onClick={() => CadastrarAcessoFilial()}
                                                    >
                                                        Adicionar
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="row tabela">
                                                <table className="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Filial</th>
                                                            <th className="acao">Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listaFilial.map(function (item, index) {
                                                            return (
                                                                <tr key={index}>
                                                                    <th>{item.filial}</th>
                                                                    <th>
                                                                        <div className="d-flex justify-content-center">
                                                                            <button
                                                                                type="button"
                                                                                className="btn fa-solid fa-trash"
                                                                                onClick={() => handleOpenFilial(item)}
                                                                            ></button>
                                                                        </div>
                                                                    </th>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={2}>Quantidade de Registros: {listaFilial.length}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-danger" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button type="button" className="btn btn-success" onClick={Salvar}>
                                            Salvar
                                        </button>

                                    </div>
                                </div>
                            </Modal>
                        </div>

                        <div className="row">
                            <h1 className="ms-4">Cadastro de Usuário</h1>
                            <p className="ms-4">Rotina para cadastrar os usuários e acessos</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Código, Nome ou Usuário"
                                    name="busca"
                                    id="busca"
                                    className="form-control"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn btn-success btnnovo"
                                    onClick={() => openModalNovo()}
                                >
                                    Novo
                                </button>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Nome</th>
                                        <th>Usuario</th>
                                        <th>Tipo Acesso</th>
                                        <th className="acao">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.codusuario}</th>
                                                <th>{item.nome}</th>
                                                <th>{item.usuario}</th>
                                                <th>{item.tipoacesso}</th>
                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-regular fa-pen-to-square"
                                                            onClick={() => openModalEditar(item)}
                                                        ></button>
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-trash"
                                                            onClick={() => handleOpen(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CadUsuario;
